export var modelJson = function () {
    return import("../../models/mobilenet_v2/model.min.js");
};
export var weightBundles = [
    function () { return import("../../models/mobilenet_v2/group1-shard1of1.min.js"); },
];
//# sourceMappingURL=mobilenet_v2.js.map